// extracted by mini-css-extract-plugin
export default {"container":"chained-board_container__BBQ0j","visible":"chained-board_visible__JIHWi"};